let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("atPXc")).then(() => parcelRequire('jZEXp'));